export const UPDATE_COMPETENCY_DATA = 'UPDATE_COMPETENCY_DATA';

export const updateCompetencyData = (payload) => {
    return {
        type: UPDATE_COMPETENCY_DATA,
        payload,
    };
};
